export const restPath = "/servoy-service/velocity/webservice_v2/";
export const apiKey = "3C7BC968-190B-4033-8349-851806E58E8C";

export const hour = 60 * 60 * 1000;
export const day = 24 * hour;



// WEBPACK FOOTER //
// ./src/app/constants.ts